import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import Spinner from "../../UI/Spinner/Spinner";

import styles from "./Billing.module.scss";

import * as Utils from "../../Utils/BillingUtils";
import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "BILLING_EDIT";

const BillingView = (props) => {

    useEffect(() => {
        LogService.debug(LOG_TAG, "useEffect: get current method");
    }, [props.payments]);
    
    const intl = useIntl();

    let status = Utils.getStateOfCC(props.payment, intl);
    let isExpired = Utils.isExpired(props.payment);

    let card = props.payment
        ? props.payment.Type === "CreditCard"
            ? props.payment.CreditCardType + "   " + props.payment.CreditCardMaskNumber
            : props.payment.BankTransferType + "   " + props.payment.BankTransferAccountNumberMask
        : "";

    let expiration = props.payment
        ? props.payment.Type === "CreditCard"
            ? props.payment.CreditCardExpirationMonth + "/" + props.payment.CreditCardExpirationYear
            : "-"
        : "-";

    let owner = props.payment
        ? props.payment.Type === "CreditCard"
            ? props.payment.CreditCardHolderName
            : props.payment.BankTransferAccountName
        : "-";

    let labelOwner = props.payment
        ? props.payment.Type === "CreditCard"
            ? intl.messages.billingCardName
            : intl.messages.billingAccountName
        : "-";

    return (
        <Card title={intl.messages.billingMethods} >
            <div className={styles.editBody}>
                <div className="row">
                    {props.progress &&
                        <div className="col text-center">
                            <Spinner />
                        </div>
                    }

                    {!props.progress &&
                        <div className="col">
                            <div className="form-group">
                                <label htmlFor="billingView-currentCard" className="input-label">{intl.messages.billingCurrentMethod}</label>
                                <input id="billingView-currentCard" className="form-control mb-3" value={card} autoComplete="off" disabled></input>
                            </div>

                            <div className="form-row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="billingView-owner" className="input-label">{labelOwner}</label>
                                        <input id="billingView-owner"
                                            className="form-control mb-3"
                                            value={owner}
                                            autoComplete="off"
                                            disabled >
                                        </input>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="billingView-expiration" className="input-label">{intl.messages.billingExpirationDate}</label>
                                        <input id="billingView-expiration"
                                            className={(isExpired) ? "form-control is-invalid" : "form-control mb-3"}
                                            value={expiration}
                                            autoComplete="off"
                                            disabled >
                                        </input>

                                        <div id="billingView-expiration-status" className="invalid-feedback">
                                            {status}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="billingView-message" className="panel bg-fog mb-3">{intl.formatMessage({ id: "billingWarning" }, { b: chunks => <b>{chunks}</b> })}</div>
                        </div>
                    }
                </div>

            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        payments: state.payments.data,
        payment: Utils.getDefaultPaymentMethod(state.payments.data),
        progress: state.payments.getPaymentMethodProgress,
    };
}

export default connect(mapStateToProps)(BillingView)